import './Footer.css'
import { Link } from 'react-router-dom'

function Footer() {
  const currentYear = new Date().getFullYear()

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-section">
          <h3>About Healthy Living Blog</h3>
          <p>
            We are dedicated to providing you with practical tips, recipes, and advice 
            for living a healthier, more sustainable lifestyle.
          </p>
        </div>

        <div className="footer-section">
          <h3>Quick Links</h3>
          <ul>
            <li><Link to="/">Home</Link></li>
            <li><Link to="/about">About</Link></li>
            <li><Link to="/privacy">Privacy Policy</Link></li>
          </ul>
        </div>


        <div className="footer-section">
          <h3>Connect With Us</h3>
          <div className="social-links">
            <a href="https://www.facebook.com/CristinaNTrujillo/" target="_blank" rel="noreferrer noopener" aria-label="Facebook">f</a>
            <a href="https://x.com/CristinaTruth" target="_blank" rel="noreferrer noopener" aria-label="X">𝕏</a>
            <a href="https://www.instagram.com/iamcristinatrujillo/" target="_blank" rel="noreferrer noopener" aria-label="Instagram">📷</a>
            <a href="https://www.linkedin.com/in/cristinantrujillo/" target="_blank" rel="noreferrer noopener" aria-label="LinkedIn">in</a>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <p>&copy; {currentYear} Healthy Living Blog. All rights reserved.</p>
      </div>
    </footer>
  )
}

export default Footer
